import React from "react";

export const useRole = () => {
  let user = {};

  const _user = localStorage.getItem("metaData");

  if (_user) {
    user = JSON.parse(_user);
  }

  if (user.roles) {
    return user.roles[0].roleName;
  } else {
    return "NoRole";
  }
};

export const Redirect = () => {
  console.log("Route Change No Role");

  window.location.href = `${process.env.PUBLIC_URL}/`;
};

/**
 * This component renders children on Specific role
 * @param {Object} props Props passed to the Element - { roleRequired = "", children, rolesRequired = [] }
 * @returns {React.ReactNode} A React element that renders children on Specific role
 */
const RolePermission = (props) => {
  const { roleRequired = "", children, rolesRequired = [] } = props;
  const role = useRole();

  if (role === "NoRole") {
    // Redirect to a specific page if role is "NoRole"
    return <Redirect />;
  }

  if (roleRequired) {
    return <>{roleRequired === role ? children : <></>}</>;
  } else {
    return <>{rolesRequired.includes(role) ? children : <></>}</>;
  }
};

export default RolePermission;

export const logoutRedirect = () => {
  localStorage.clear();
  sessionStorage.clear();
  window.location.replace(`${process.env.PUBLIC_URL}`);
  window.location.reload(true); // Forces reload without using cache

};
